import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LandingNav } from '../components/landing/LandingNav';
import { useLanguage } from '../contexts/LanguageContext';
import { Hero } from '../components/landing/Hero';
import { DemoDeck } from '../components/landing/DemoDeck';
import { TwoSides } from '../components/landing/TwoSides';
import { PlayfulBreak } from '../components/landing/PlayfulBreak';
import { TrustRow } from '../components/landing/TrustRow';
import { PricingPlans } from '../components/landing/PricingPlans';
import { FinalCta } from '../components/landing/FinalCta';
import { SiteFooter } from '../components/landing/SiteFooter';
export function Landing() {
  const {
    hash
  } = useLocation();
  const {
    t
  } = useLanguage();
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({
      behavior: 'smooth'
    });else window.scrollTo(0, 0);
  }, [hash]);
  return <div className="min-h-screen w-full bg-bg text-ink" data-id="element-872" data-mp="m83gkbpsjhmo">
      <LandingNav data-id="element-873" data-mp="2ajuj2ew88b9" />
      <main data-id="element-874" data-mp="2b38k81fack0">
        <Hero data-id="element-875" data-mp="2blha459uj8t" />
        <DemoDeck data-id="element-876" data-mp="2bbm825ddlw9" />
        <TwoSides data-id="element-877" data-mp="3tgbfzohq6wrq" />
        <PlayfulBreak data-id="element-878" data-mp="3tftnn2y6p2p3" />
        <TrustRow data-id="element-879" data-mp="3tfa1tb5exu5s" />
        <section id="pricing" aria-labelledby="pricing-title" className="mx-auto max-w-6xl scroll-mt-24 px-5 pb-24" data-id="element-880" data-mp="3tes1o3fmqvsl">
          <h2 id="pricing-title" className="max-w-[18ch] text-[32px] font-bold leading-[1.08] tracking-[-0.015em] lg:text-[44px]" data-id="element-881" data-mp="3pguboye1c5o5">
            {t('pricing.title')}
          </h2>
          <div className="mt-10" data-id="element-882" data-mp="l008osji3za5">
            <PricingPlans data-id="element-883" data-mp="gywq3ya2jp58" />
          </div>
        </section>
        <FinalCta data-id="element-884" data-mp="gzgb5nv0mtnh" />
      </main>
      <SiteFooter data-id="element-885" data-mp="h1amcaghj7ed" />
    </div>;
}